<template lang="html">
  <v-speed-dial
    v-model="viewerDisplay"
    direction="top"
    class="view-layout-dial"
  >
    <template v-slot:activator>
      <v-tooltip top :open-delay="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="dial-activator"
          >
            <v-icon :size="24">mdi-view-grid-outline</v-icon>
          </v-btn>
        </template>
        <span>View Layout Options</span>
      </v-tooltip>
    </template>

    <!-- Layout Options - Always use dark SVGs for dark sidebar -->
    <v-btn icon class="layout-option" @click="selectViewOption(0)">
      <v-img width="32px" src="/img/square-svgrepo-com-dark.svg" />
    </v-btn>
    <v-btn icon class="layout-option" @click="selectViewOption(1)">
      <v-img width="32px" src="/img/grid-9-svgrepo-com-dark.svg" />
    </v-btn>
    <v-btn icon class="layout-option" @click="selectViewOption(2)">
      <v-img width="32px" src="/img/grid-5-svgrepo-com-dark.svg" />
    </v-btn>
    <v-btn icon class="layout-option" @click="selectViewOption(3)">
      <v-img width="32px" src="/img/grid-2-svgrepo-com-dark.svg" />
    </v-btn>
  </v-speed-dial>
</template>

<script>
/**
 * ViewerDisplayOptions Component
 *
 * Grid layout selector for the viewer - used in the dark sidebar navigation.
 * Opens upward to display layout options (1x1, 3x3, 2x2, 1x2 grids).
 */
export default {
  name: 'ViewerDisplayOptions',

  // Keep compact prop for backward compatibility (ignored now)
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    viewerDisplay: false,
  }),

  computed: {
    mainApp() {
      return this.$store.state.mainApp;
    },
  },

  methods: {
    selectViewOption(option) {
      this.mainApp.selectViewOption(option);
      this.viewerDisplay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.view-layout-dial {
  z-index: 200 !important;
  position: relative;

  // Activator button - transparent, matches group icon style
  .dial-activator {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    background: transparent !important;
    box-shadow: none !important;

    &::before {
      display: none !important;
    }

    .v-icon {
      color: rgba(255, 255, 255, 0.7) !important;
    }

    &:hover .v-icon {
      color: rgba(255, 255, 255, 1) !important;
    }
  }
}
</style>

<style lang="scss">
// Global styles for speed-dial list (unscoped - needed for Vuetify's portal rendering)
.view-layout-dial .v-speed-dial__list {
  z-index: 201 !important;

  .layout-option {
    width: 44px !important;
    height: 44px !important;
    background: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 16px !important;
    box-shadow: none !important;
    transition: all 0.15s ease !important;

    &:hover {
      background: rgba(255, 255, 255, 0.1) !important;
      border-color: rgba(255, 255, 255, 0.4) !important;
    }

    .v-image {
      opacity: 0.8;
    }

    &:hover .v-image {
      opacity: 1;
    }
  }
}
</style>
